module.exports = __webpack_public_path__ + "static/media/photo156.fe64724c.jpg";